import * as React from "react";
// import Typography from "@mui/material/Typography";
// import Breadcrumbs from "@mui/material/Breadcrumbs";
import { Breadcrumbs as MUIBreadcrumbs } from "@material-ui/core";
import { Home } from "@material-ui/icons";

import { Container, Link, CurrentPage } from "./styles";

function handleClick(event: React.MouseEvent<HTMLDivElement, MouseEvent>) {
  event.preventDefault();
}

interface Path {
  link: string;
  title: string;
}

export interface BreadcrumbsProps {
  currentPage: string;
  paths: Path[];
}

export default function Breadcrumbs({ paths, currentPage }: BreadcrumbsProps) {
  return (
    <Container role="presentation" onClick={handleClick}>
      <Home />

      <MUIBreadcrumbs aria-label="breadcrumb">
        {paths.map((path) => (
          <Link to={path.link} key={path.link}>
            {path.title}
          </Link>
        ))}

        <CurrentPage>{currentPage}</CurrentPage>
      </MUIBreadcrumbs>
    </Container>
  );
}
